import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
  provideZoneChangeDetection,
} from '@angular/core';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, Router, withRouterConfig } from '@angular/router';
import { environment } from '@environments/_current/environment';
import {
  provideTranslateService,
  TranslateLoader,
  TranslateService,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import * as Sentry from '@sentry/angular';
import { routes } from './app.routes';
import { adminInterceptor } from './services/admin-interceptor/admin-interceptor';

/**
 * We are using versioning for the translations in Legacy. If we are supporting
 * this we need to make sure we build the translation files like that too.
 * new TranslateHttpLoader(http, './assets/i18n/', `.json?v=${VERSION.hash}`)
 */
const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (
  http: HttpClient
) => new TranslateHttpLoader(http, './assets/i18n/', `.json`);

export function initializeTranslator(translate: TranslateService) {
  return () => {
    translate.setDefaultLang('en');
    return translate.use('en').toPromise();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withRouterConfig({onSameUrlNavigation: 'reload'})),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([adminInterceptor])),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    provideFirebaseApp(() => {
      return initializeApp(environment.firebase);
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeTranslator,
      multi: true,
      deps: [TranslateService],
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: 'env',
      useValue: environment,
    },
    // { provide: ErrorHandler, useClass: GlobalErrorHandler },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: SentryErrorInterceptor,
    //   multi: true,
    // },
  ],
};
